import React from "react";
import { useEmployeeData } from "../../context/EmployeeContext";import "../../assets/styles/Employee/EmpPerformancePage.css";

function EmpPerformancePage() {
  const { empPerformance } = useEmployeeData();
  const latest = empPerformance.length > 0 ? empPerformance[0] : null;

  return (
    <div>
      <div className="grid-2 mb-24">
        <div className="card animate-in">
          <div className="card-header"><div className="card-title">Current Rating</div><div className="card-subtitle">{latest ? latest.cycle_name : 'No recent review'}</div></div>
          <div className="card-body empperformancepage-inline-1">
            <div className="empperformancepage-inline-2">{[1, 2, 3, 4, 5].map((i) => <span key={i} style={{ "--empperformancepage-1-color": i <= (latest ? latest.rating : 0) ? "#f59e0b" : "#e2e8f0" }} className="empperformancepage-dyn-1">{i <= (latest ? latest.rating : 0) ? "★" : "☆"}</span>)}</div>
            <div className="empperformancepage-inline-3">{latest ? latest.rating : '—'}<span className="empperformancepage-inline-4">/5</span></div>
            <div className="empperformancepage-inline-5">{latest ? latest.status : 'No data'}</div>
          </div>
        </div>
        <div className="card animate-in delay-2">
          <div className="card-header"><div className="card-title">Review History</div></div>
          <div className="card-body">
            {empPerformance.length === 0 ?
            <div className="empperformancepage-inline-6">No review history found</div> :
            empPerformance.map((pr, i) =>
            <div className="list-item" key={i}>
                <div className="list-content"><div className="list-title">{pr.cycle_name}</div><div className="list-sub">{pr.status || 'Reviewed'}</div></div>
                <div style={{ "--empperformancepage-2-color": pr.rating >= 4 ? "#2563eb" : "#4f46e5" }} className="empperformancepage-dyn-2">{pr.rating}/5</div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card animate-in delay-3">
        <div className="card-header"><div className="card-title">Skills</div></div>
        <div className="card-body">
          <div className="skills-grid">
            {[["Communication", 90, "#4f46e5"], ["Technical Proficiency", 85, "#2563eb"], ["Reliability", 88, "#f59e0b"], ["Teamwork", 92, "#ec4899"]].map(([sk, pct, cl], i) =>
            <div className="skill-item" key={i}>
                <div className="skill-header"><span>{sk}</span><span style={{ "--empperformancepage-3-color": cl }} className="empperformancepage-dyn-3">{pct}%</span></div>
                <div className="skill-bar"><div className="skill-fill empperformancepage-dyn-4" style={{ "--empperformancepage-4-width": `${pct}%`, "--empperformancepage-4-background": cl }} /></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>);

}

export default EmpPerformancePage;